import type { ModelStorageFileDescription } from '@app/api/Branches';
import type { NLeavePageProvider } from '@app/providers/LeavePageProvider/LeavePageProvider.types';
import type { NUsers } from '@app/types/Users';

import type { ItemProps } from '@pages/Branches/BranchesList/data/StatusOptions';

import type { FormInstance } from 'antd';

/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: здесь типы Any планируется убрать отдельным этапом в рамках task/3444,
// т.к. у нас завязано 62 места в кодовой базе только на setNewData,
// не считая других переменных из LeavePageProvider

export namespace NBranches {
  export type Branch = ExistedBranch | null;

  export interface DaysWithPostfix {
    moE?: DayWithPostfix;
    moS?: DayWithPostfix;
    tuE?: DayWithPostfix;
    tuS?: DayWithPostfix;
    weE?: DayWithPostfix;
    weS?: DayWithPostfix;
    thE?: DayWithPostfix;
    thS?: DayWithPostfix;
    frE?: DayWithPostfix;
    frS?: DayWithPostfix;
    saE?: DayWithPostfix;
    saS?: DayWithPostfix;
    suE?: DayWithPostfix;
    suS?: DayWithPostfix;
  }
  export interface ExistedBranch extends DaysWithPostfix {
    address: string | null;
    city: string;
    countUsers?: number;
    createUserId?: number;
    id: number;
    isDeleted: boolean;
    name: string;
    chainId?: number;
    organizationName: string | null;
    timeCreated?: string;
    timezone: string | null;
    countryId?: number;
    legalEntityId?: number;
    legalEntity?: string | null;
    notificationsAddress?: string | null;
    notificationsPhone?: string | null;
    comment: string | null;
    instructionFile?: ModelStorageFileDescription;
    warehouseId: number | null;
  }

  export type DayWithPostfix = string | null;

  export type BranchesForSystem = {
    Id: number;
    Name: string | null;
    Address: string | null;
  };

  export type ModelBranchItem = BranchesForSystem;

  export type ModalFormProps = {
    open: boolean;
    selectedBranches: NBranches.ModelBranchItem[];
    onCancel: () => void;
    setSelectedBranches: (chain: NBranches.ModelBranchItem[]) => void;
    allBranches: NBranches.ModelBranchItem[];
    serverError?: string;
    showUserModal: () => void;
    tooltipLabel?: string;
    infoData?: any;
    setInfoData?: (value: any) => void;
    dataKey?: string;
    user?: NUsers.User;
    setNewData?: NLeavePageProvider.SetData;
    newDataFieldValue?: string;
    error?: string | null;
    checkBranchSelection?: (
      checkedBranches?: NBranches.BranchesForSystem[]
    ) => void;
    required?: boolean;
  };

  export type SelectorProps = {
    defaultData: any[];
    form: FormInstance;
    fieldName: string;
    options: {
      label: string;
      value: string;
    }[];
    fieldLabel: string;
    checkboxStatus: boolean;
  };

  export type GetSelectorOptionsProps = {
    flag: string;
    defaultData: any[];
    setOptions: (arg: ItemProps[]) => void;
    setData?: (arg: string[]) => void;
    form?: FormInstance;
    editableChainId?: number | null;
  };

  export type ModelBranchSearchFilter = {
    SearchTerm: string | null;
    ChainIds: number[] | null;
    CountryIds: number[] | null;
    Cities: string[] | null;
    Statuses: string[] | null;
    BranchesPerPage: number;
    PageN: number;
  };

  export type BranchForRegistry = {
    address: string | null;
    city: string;
    countUsers?: number;
    createUserId?: number;
    key: number;
    id: number;
    status: string;
    isDeleted: boolean;
    name: string;
    organizationName?: string | null;
    timeCreated?: string;
    timezone: string | null;
  };

  export type ModelBranchForFront = {
    Id: number;
    Name: string;
    Timezone: null;
    CountryId: number;
    City: string;
    Address: string | null;
    OrganizationName?: string | null;
    IsDeleted: boolean;
    LegalEntityId: number;
    LegalEntity: string | null | undefined;
    CountUsers?: number;
    CreateUserId?: number;
    TimeCreated?: string;
    ChainId?: number;
  };

  export type ModelBranchRequiredRequestParams = WorkSlots & {
    Id: number;
    LegalEntityId: number;
    LegalEntity: string | null;
    Timezone: string | null;
    ChainId: number;
    CountryId: number;
    City: string | null;
    Address: string | null;
    NotificationsAddress: string | null;
    NotificationsPhone: string | null;
    IsDeleted: boolean;
    WarehouseId: number | null;
  };

  export type ModelBranchOptionalRequestParams = BreakSlots & {
    Name: string | null;
    TimeCreated: string;
    CreateUserId: number;
    Country: string | null;
    OrganizationName: string | null;
    Coordinates: string | null;
    CountUsers: number;
    IsWorkOutsideSchedule: boolean;
    MigrateId: number | null;
  };

  export type WorkSlots = {
    MoS: string | null;
    MoE: string | null;
    TuS: string | null;
    TuE: string | null;
    WeS: string | null;
    WeE: string | null;
    ThS: string | null;
    ThE: string | null;
    FrS: string | null;
    FrE: string | null;
    SaS: string | null;
    SaE: string | null;
    SuS: string | null;
    SuE: string | null;
  };

  export type BreakSlots = {
    MoBreakS: string | null;
    MoBreakE: string | null;
    TuBreakS: string | null;
    TuBreakE: string | null;
    WeBreakS: string | null;
    WeBreakE: string | null;
    ThBreakS: string | null;
    ThBreakE: string | null;
    FrBreakS: string | null;
    FrBreakE: string | null;
    SaBreakS: string | null;
    SaBreakE: string | null;
    SuBreakS: string | null;
    SuBreakE: string | null;
  };

  export type UserBranch = {
    BranchId: number | null;
    Chain: string | null;
    ChainId: number | null;
    City: string | null;
    Country: string | null;
    CountryId: number | null;
    IsSelected: boolean | null;
    Name: string | null;
  };

  export type ModelBranchLite = {
    BranchId: number;
    Name: string | null;
    CountryId: number;
    Country: string | null;
    City: string | null;
    IsSelected: boolean;
    ChainId: number;
    Chain: string | null;
  };

  export type UpdateRecordRequestParams = {
    userId: number | null;
    database: string | null;
    activeBranchId: number | null;
    data: any;
  };

  export type ModelSetUserActiveBranch = {
    BranchId: NBranches.ExistedBranch['id'];
    Branch: string;
    CountryId: number;
  };

  export type ModelBranchesList = {
    Branches: ModelBranchForFront[] | null;
    CountActive: number;
    CountDeleted: number;
  };

  export type ModelFullBranch = {
    Id: number;
    TimeCreated: string;
    CreateUserId: number;
    LegalEntityId: number;
    LegalEntity: string | null;
    Name: string;
    Timezone: string;
    ChainId: number;
    CountryId: number;
    Country: string | null;
    City: string;
    Address: string;
    OrganizationName: string | null;
    Coordinates: string;
    IsDeleted: boolean;
    CountUsers: number;
    MoS: string | null;
    MoE: string | null;
    TuS: string | null;
    TuE: string | null;
    WeS: string | null;
    WeE: string | null;
    ThS: string | null;
    ThE: string | null;
    FrS: string | null;
    FrE: string | null;
    SaS: string | null;
    SaE: string | null;
    SuS: string | null;
    SuE: string | null;
    MoBreakS: string | null;
    MoBreakE: string | null;
    TuBreakS: string | null;
    TuBreakE: string | null;
    WeBreakS: string | null;
    WeBreakE: string | null;
    ThBreakS: string | null;
    ThBreakE: string | null;
    FrBreakS: string | null;
    FrBreakE: string | null;
    SaBreakS: string | null;
    SaBreakE: string | null;
    SuBreakS: string | null;
    SuBreakE: string | null;
    MigrateId: string | null;
    NotificationsAddress: string | null;
    NotificationsPhone: string | null;
    Comment: string | null;
    InstructionFile: ModelStorageFileDescription;
    WarehouseId: number | null;
  };
}
